import type { ComponentType } from "react";
import { ChatStepId, type ChatTurnProps } from "../types/chat";
import { CnpTurn } from "./CnpTurn";
import { BcConsentTurn } from "./BcConsentTurn";
import { EmailTurn } from "./EmailTurn";
import { BcScoringTurn } from "./BcScoringTurn";
import { TermsTurn } from "./TermsTurn";
import { IncomeTurn } from "./IncomeTurn";
import { PreliminaryOfferTurn } from "./PreliminaryOfferTurn";
import { ActiveLoanTurn, getActiveLoanScreen } from "./ActiveLoanTurn";
import { KycFailedTurn, getKycFailedScreen } from "./KycFailedTurn";
import { ApplicationTurn, getApplicationScreen } from "./ApplicationTurn";
import { OfferRequestTurn, getOfferRequestScreen } from "./OfferRequestTurn";
import { ProofOfIncomeTurn, getProofOfIncomeScreen } from "./ProofOfIncomeTurn";

// Steps answered in the chat. Every other step still opens its screen.
const chatTurns: Partial<Record<ChatStepId, ComponentType<ChatTurnProps>>> = {
  [ChatStepId.ActiveLoan]: ActiveLoanTurn,
  [ChatStepId.KycFailed]: KycFailedTurn,
  [ChatStepId.Cnp]: CnpTurn,
  [ChatStepId.BcConsent]: BcConsentTurn,
  [ChatStepId.Email]: EmailTurn,
  [ChatStepId.Income]: IncomeTurn,
  [ChatStepId.BcScoring]: BcScoringTurn,
  [ChatStepId.PreliminaryOffer]: PreliminaryOfferTurn,
  [ChatStepId.Terms]: TermsTurn,
  [ChatStepId.AnafConsent]: TermsTurn,
  [ChatStepId.OfferRenewal]: TermsTurn,
  [ChatStepId.OfferRequest]: OfferRequestTurn,
  [ChatStepId.ProofOfIncome]: ProofOfIncomeTurn,
  [ChatStepId.Application]: ApplicationTurn,
};

export const getChatTurn = (
  stepId: ChatStepId,
): ComponentType<ChatTurnProps> | null => chatTurns[stepId] ?? null;

// Steps whose turn opens their screen at once rather than asking: where to,
// or null to ask in the chat after all.
const screensOpenedAtOnce: Partial<
  Record<
    ChatStepId,
    (props: ChatTurnProps, locationState: unknown) => string | null
  >
> = {
  [ChatStepId.ActiveLoan]: getActiveLoanScreen,
  [ChatStepId.KycFailed]: getKycFailedScreen,
  [ChatStepId.Application]: getApplicationScreen,
  [ChatStepId.OfferRequest]: getOfferRequestScreen,
  [ChatStepId.ProofOfIncome]: getProofOfIncomeScreen,
};

export const getScreenOpenedAtOnce = (
  props: ChatTurnProps,
  locationState: unknown,
): string | null =>
  screensOpenedAtOnce[props.step.id]?.(props, locationState) ?? null;
